import React, {useMemo} from "react";
import GridCards from "@/components/common/Cards/Grid";
import {getPaddingsClassFromData, removeDuplicatesByProp} from "@/utils/utils";
import {useBranch} from "@/hooks/useBranch";
import Container from "@/components/common/Container";
import {GLOBAL_STATE, PADDING} from "@/constants";
import {formatToCardItem} from "@/components/common/Cards";
import useGlobals from "@/hooks/useGlobals";
import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock";


const filterDataByState = (data = [], state = '') => {
	return data.filter((item) => {
		return item?.state?.handle.toLowerCase() === state.toLowerCase()
	})
}


export const generateUrls = (data = []) => {
	return data.map(item => formatToCardItem(item))
}

const getDataWithUrlsFilteredByState = (data, state) => {
	//duplicates removed because of AB variants
	//demands variants to have the slug
	const filteredData = filterDataByState(removeDuplicatesByProp(data, 'slug'), state);
	return generateUrls(filteredData);
}

export default function WhatWeDoCategoryPageGridCards({ id='category-actions', data = [], horizontalCards = false }) {
	const actionsCardsHeader = useGlobals(state => state.actionsCardsHeader)
	const { selectedOption } = useBranch();
	const paddings = getPaddingsClassFromData({
		paddings: {
			top: PADDING.SMALL,
			bottom: PADDING.SMALL
		},
	})

	const dataWithGlobalState = useMemo(() => getDataWithUrlsFilteredByState(data, GLOBAL_STATE), [data]);
	const dataWithSelectedState = useMemo(() => getDataWithUrlsFilteredByState(data, selectedOption), [selectedOption, data]);

	const cardsData = useMemo(() => (
		selectedOption === GLOBAL_STATE ? dataWithGlobalState : [...dataWithGlobalState, ...dataWithSelectedState]
	), [dataWithGlobalState, dataWithSelectedState, selectedOption]);

	return (
		!!cardsData.length && (
			<div id={id} className={`${paddings}`}>
				<HeaderDescriptionBlock headerDescription={{ header: actionsCardsHeader, columnStart: '0' }} />
				<Container>
					<GridCards data={cardsData} horizontalCards={horizontalCards} />
				</Container>
			</div>
		)
	)
}
